import './styles.scss'
import React, { useEffect, useState } from 'react'
import { CoffeeBeanIcon } from 'Assets/Icons'

const CoffeeBeanConfetti = ({ trigger }) => {
  const [beans, setBeans] = useState([])

  useEffect(() => {
    let interval
    let timeout

    if (trigger) {
      interval = setInterval(() => {
        setBeans((prev) => [
          ...prev,
          {
            id: Date.now() + Math.random(),
            left: Math.random() * 100,
            size: 16 + Math.random() * 20,
            rotation: Math.random() * 360,
            duration: 3 + Math.random() * 3
          }
        ])
      }, 30)

      timeout = setTimeout(() => {
        clearInterval(interval)
      }, 2000)
    } else {
      setBeans([])
    }

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [trigger])

  return (
    <div className="confetti-container">
      {beans.map((bean) => (
        <div
          key={bean.id}
          className="coffee-bean"
          style={{
            left: `${bean.left}%`,
            width: `${bean.size}px`,
            height: `${bean.size}px`,
            animationDuration: `${bean.duration}s`,
            transform: `rotate(${bean.rotation}deg)`
          }}
        >
          <CoffeeBeanIcon fill="#A48011" />
        </div>
      ))}
    </div>
  )
}

export default CoffeeBeanConfetti
